module.exports = __webpack_public_path__ + "static/media/US.049c5ec9.png";